<script>
import CompanyInput from "./CompanyInput.vue"
import AdminService from "@/services/AdminServices"

export default {
  name: "AdminCompanyInput",
  extends: CompanyInput,
  methods: {
    getData() {
      return AdminService.getCompanies()
    }
  }
}
</script>
